// extracted by mini-css-extract-plugin
export var cardContainer = "_r3-0";
export var cardHeader = "_r3-2";
export var collapsedState = "_r3-3";
export var dragHandle = "_r3-5";
export var dragHandleIcon = "_r3-6";
export var dragging = "_r3-1";
export var titleArea = "_r3-4";